import { useEffect, useState } from "react";

export function deviceType() {
  const w = window.innerWidth;
  if (w < 768) return "mobile";
  if (w < 1100) return "tablet";
  return "desktop";
}

export function useDeviceType() {
  const [d, setD] = useState(deviceType());
  useEffect(() => {
    const onResize = () => setD(deviceType());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  return d;
}

export function isPageRestricted(user, module, device) {
  const r = user?.page_restrictions || {};
  return (r[module] || []).includes(device);
}
